import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App'
import './styles.css'
import { installErrorReporter } from './lib/errorReporter'
import { initErrorMonitor } from './lib/errorMonitor'
import { initClientErrorSink } from './lib/clientErrorSink'
import { initAnalytics } from './lib/analytics'
import { applyAccentToDom } from './lib/theme'
import { registerShortcutProtocol } from './lib/siriShortcut'

installErrorReporter()
void initErrorMonitor()
initClientErrorSink()
initAnalytics()
applyAccentToDom()
registerShortcutProtocol()

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: true,
      retry: 1,
    },
  },
})

// Expose the QueryClient to non-React modules (appStore + realtime bridge) so
// they can invalidate queries in response to remote events without prop drilling.
;(globalThis as unknown as { __babyos_qc?: QueryClient }).__babyos_qc = queryClient
export function getQueryClient(): QueryClient {
  const qc = (globalThis as unknown as { __babyos_qc?: QueryClient }).__babyos_qc
  if (!qc) throw new Error('QueryClient not initialized yet')
  return qc
}

const root = document.getElementById('root')
if (!root) throw new Error('#root element missing')

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
)
